import { fetchAllCategories } from '../../../../common/actions/fetch-categories';

export const movePostModalDataLoader = fetchAllCategories;
